<al-tabs [tabInfo]="tabInfo" [selectedTab$]="selectedTab$"></al-tabs>

<div *ngIf="this.link.id && linkInfo" class="tabs-container">
	<ng-container [ngSwitch]="selectedTab$ | async">
		<!--<al-link-edit-statistics *ngSwitchCase="1" [link]="link"></al-link-edit-statistics>-->
		<al-link-edit-setup *ngSwitchCase="2" [link]="link" [linkInfo]="linkInfo"></al-link-edit-setup>
		<al-link-edit-schedular *ngSwitchCase="3" [link]="link" [linkInfo]="linkInfo"></al-link-edit-schedular>
		<al-link-log *ngSwitchCase="4" [link]="link" [cspMode]="cspMode" [deepLink]="routeQueryParams"></al-link-log>
		<al-link-edit-support *ngSwitchCase="5" [link]="link" [linkInfo]="linkInfo"></al-link-edit-support>
		<al-link-edit-activity *ngSwitchCase="6" [link]="link"></al-link-edit-activity>
	</ng-container>
</div>
